<ion-content [scrollY]="false" [scrollX]="false" slot="fixed" *ngIf="entered">
  <div class="login__background"></div>
  <div class="change-language" *ngIf="!loginType" (click)="changeLanguage()">
    <span>{{ getCurrentLang() | uppercase }}</span>
    <ion-icon name="chevron-down"></ion-icon>
  </div>
  <!-- Form -->
  <form [formGroup]="loginForm" (ngSubmit)="login()">
    <!-- Logo -->
    <div class="login__logo" [class.staging]="isStagingEnv">
      <img src="/assets/images/logo-yova.png" alt="Logo yova" />
      <span class="app-version">{{ thirdParties?.deviceInfo?.version + ' - ' + thirdParties?.deviceInfo?.build }}</span>
    </div>
    <!-- Content -->
    <div class="container container--center">
      <!-- Known login type -->
      <div class="login__logged-user" *ngIf="loginType">
        <h1 *ngIf="firstName">{{ 'PUBLIC.reLogin.' + dayTime | translate }} {{ firstName }}</h1>
        <h1 *ngIf="!firstName" [ngClass]="{ welcome: getCurrentLang() === 'fr' }">{{ 'PUBLIC.login.welcome' | translate }}</h1>
        <p class="email">{{ email }}</p>
        <!-- Login type is Email -->
        <div *ngIf="loginType === LoginType.EMAIL" class="login__logged-user-password">
          <!-- Email -->
          <input type="email" [value]="email" hidden />
          <!-- Password -->
          <ion-item class="item-input item-interactive" mode="md">
            <ion-input
              label="{{ 'PUBLIC.password.capitalised' | translate }}"
              labelPlacement="stacked"
              #passwordKnown
              autocomplete="off"
              aria-label="Password"
              [type]="passwordVisible ? 'text' : 'password'"
              (keyup.enter)="login()"
              clear-on-edit="false"
              formControlName="password"
            ></ion-input>
            <ion-icon
              [name]="passwordVisible ? 'eye-off' : 'eye'"
              color="primary"
              slot="end"
              (click)="passwordVisible = !passwordVisible; passwordKnown.setFocus()"
            ></ion-icon>
          </ion-item>
          <div class="ion-input__errors ion-input__errors--forgot-password">
            <span *ngIf="hasError('password', 'required')">{{ 'PUBLIC.password.empty' | translate }}</span>
          </div>
          <div class="login__forgot-password">
            <a (click)="resetPassword()">{{ 'PUBLIC.password.forgot' | translate }}</a>
          </div>
          <!-- Log in -->
          <ion-button type="submit" mode="ios" expand="block">{{ 'SHARED.actions.logIn' | translate }}</ion-button>
        </div>
        <!-- Login type is Google -->
        <ion-button class="login__google" *ngIf="loginType === LoginType.GOOGLE" (click)="loginWithOauth()" mode="ios" expand="block" color="white">
          <ion-icon color="primary" slot="start" name="logo-google"></ion-icon>
          {{ 'SHARED.actions.signInGoogle' | translate }}
        </ion-button>
        <!-- Biometric login -->
        <p class="login__biometric" *ngIf="biometricLoginPref" (click)="loginWithBiometric()">
          {{ 'SHARED.actions.withFaceId' | translate }}
        </p>
      </div>
      <!-- Unknown login type -->
      <div *ngIf="!loginType" class="login__logged-user">
        <h1>{{ 'PUBLIC.login.neutral' | translate }}</h1>
        <div class="email"></div>
        <!-- Email -->
        <ion-item class="item-input item-interactive" mode="md">
          <ion-input
            label="{{ 'PUBLIC.email.capitalised' | translate }}"
            labelPlacement="stacked"
            autocomplete="email"
            type="email"
            (keyup.enter)="getProvider()"
            formControlName="login"
          ></ion-input>
        </ion-item>
        <div class="ion-input__errors">
          <span *ngIf="hasError('login', 'required')">{{ 'PUBLIC.email.empty' | translate }}</span>
          <span *ngIf="!hasError('login', 'required') && hasError('login', 'email')">{{ 'PUBLIC.email.incorrectFormat' | translate }}</span>
        </div>
        <div class="login__forgot-password"></div>
        <!-- Log in -->
        <ion-button (click)="getProvider()" mode="ios" expand="block">{{ 'SHARED.actions.next' | translate }}</ion-button>
      </div>
    </div>
  </form>
  <!-- Sign up -->
  <div class="login__signup">
    <!-- Known login type -->
    <div *ngIf="loginType">
      <p (click)="switchCustomer()">{{ 'SHARED.actions.switchAccount' | translate }}</p>
    </div>
    <!-- Unknown login type -->
    <p *ngIf="!loginType">
      {{ 'SHARED.actions.noAccount' | translate }}
      <b>
        <a data-cy="public.login.signup" (click)="openSignupRedirect()">{{ 'SHARED.actions.signUp' | translate }}</a>
      </b>
    </p>
  </div>
</ion-content>

<app-force-update *ngIf="isNewAppVersionAvailable && !thirdParties.maintenance"></app-force-update>
<app-maintenance *ngIf="thirdParties.maintenance"></app-maintenance>
